// Consultation/ConsultationStatus.tsx
import React, {useContext} from 'react';
import {IConsultation} from "../../Types/psychology/consultation";
import {useTheme} from "Theme/ThemeContext";
import {AuthContext, AuthContextType} from "Auth/AuthContext";

interface ConsultationStatusProps {
    consultation: IConsultation;
    cls?: string;
}

const ConsultationStatus: React.FC<ConsultationStatusProps> = ({consultation, cls}) => {
    const {plt} = useTheme();
    const {user} = useContext(AuthContext) as AuthContextType;

    const {status, date, feedbacks} = consultation;
    const now = new Date();
    const consultationDate = date ? new Date(date) : null;
    const userFeedback = feedbacks?.find(fb => fb.user === user?.id);
    const dateInPast = consultationDate && consultationDate < now;

    let label: string;
    if (status === 'NEW') {
        label = 'Не оплачена';
    } else if (status === 'CANCELLED') {
        label = 'Отменена';
    } else if (status === 'PAID') {
        if (dateInPast) {
            // Консультация прошла
            if (userFeedback) {
                label = 'Завершена';
            } else {
                label = ''//'Ожидает отзыва';
            }
        } else {
            // Дата в будущем
            label = 'Оплачена'//'Запланирована';
        }
    } else {
        // Не должно случиться, но на всякий
        label = 'Неизвестен';
    }

    return (
        label ?
            <span className={cls} style={{
                color: label === 'Отменена'
                    ? plt.colors.error.main
                    : plt.colors.secondary.main,
                textShadow: plt.shadow.XXSO02C,
            }}>
            {label}
        </span>
            : ''
    );
};

export default ConsultationStatus;
